import { Component, HostListener, OnInit } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/index';

export interface ConfirmDialogResult {
    isConfirmed: boolean;
    data?: any;
}

export const createConfirmModalOptions =
    (title: string, message: string, okLabel: string, cancelLabel: string, data?: any): ModalOptions => ({
    initialState: {
        title,
        message,
        okLabel,
        cancelLabel,
        data
    },
    backdrop: 'static'
});



export const createConfirmRetryModalOptions = (title: string, message: string, data?: any): ModalOptions => ({
    initialState: {
        title,
        message,
        okLabel: 'Retry',
        data
    },
    backdrop: 'static'
});

@Component({
    selector: 'modal-confirm',
    template: `
    <div class="modal-header">
      <button type="button" class="close" (click)="bsModalRef.hide()">&times;</button>
      <h4 class="modal-title">{{ title || 'Confirm' }}</h4>
    </div>
    <div class="modal-body">
      <p>{{ message || 'Are you sure?' }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="onConfirm()">{{ okLabel || 'OK' }}</button>
      <button type="button" class="btn btn-default" (click)="onCancel()">{{ cancelLabel || 'Cancel' }}</button>
    </div>
  `
})

export class BsModalConfirmComponent implements OnInit {

    // These fields will be set if provided in initialState

    title: string;
    message: string;
    okLabel: string;
    cancelLabel: string;
    data: any;

    result: ConfirmDialogResult = {isConfirmed: false};

    public onClose: Subject<ConfirmDialogResult>;

    constructor(public bsModalRef: BsModalRef) {}

    public ngOnInit(): void {
        if (this.data !== undefined) {
            this.result.data = this.data;
        }
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.result.isConfirmed = true;
        this.bsModalRef.hide();
        this.onClose.next(this.result);
    }

    public onCancel(): void {
        this.bsModalRef.hide();
        this.onClose.next(this.result); // default false
    }

    @HostListener('document:keypress', ['$event'])
    keyEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onConfirm();
        }
    }
}
